<template>
  <span>
    <div class="LL_VGj" v-for="(item, idx) in value" :key="idx">
      <div class="RxDe5g">{{ item.name }}, {{ item.country_code }}</div>
      <div class="ulODKO">
        <div
          v-for="(itemC, idxc) in item.children"
          :key="idxc"
          :class="`bDbG1b o9dT5G UPwwP4  ${
            idx == value.length - 1 ? 'efpa_k' : ''
          } ${
            idx == value.length - 1 && idxc == item.children.length - 1
              ? ' Xe1WSs'
              : ''
          }  ${idxc == item.children.length - 1 ? 'cYtFlT' : ''}`"
        >
          {{ itemC.description }}
          <svg
            v-if="idx == value.length - 1 && idxc == item.children.length - 1"
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="CsxG4o"
          >
            <circle cx="8" cy="8" r="8" fill="#28938D"></circle>
            <path
              d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12ZM5.365 7.866a.462.462 0 0 1 .652-.003l1.521 1.51V5.519a.462.462 0 0 1 .924 0v3.854l1.52-1.51a.462.462 0 0 1 .65.656l-2.307 2.29a.462.462 0 0 1-.65 0L5.367 8.52a.462.462 0 0 1-.002-.653Z"
              fill="#fff"
            ></path>
          </svg>
        </div>
      </div>
      <div class="ulODKO">
        <!-- cYtFlT Xe1WSs -->
        <div
          v-for="(itemC2, idxc2) in item.children"
          :key="idxc2"
          style="height: 14px"
          :class="`bDbG1b  UPwwP4  ${
            idx == value.length - 1 && idxc2 == item.children.length - 1
              ? 'Xe1WSs'
              : ''
          } ${idxc2 == item.children.length - 1 ? 'cYtFlT' : ''}`"
        >
          {{ moment(itemC2.date).format("DD MMM YYYY HH:mm:ss") }}
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      moment,
     
    };
  },
};
</script>
